import { LocaleDomain } from '../../Types.js'

const values: LocaleDomain = {
  suffix: ['com', 'biz', 'info', 'name', 'net', 'org'],
}

export default values
